import React, { useState, useEffect } from 'react';
import { Button, Icon, Alert } from '@polichat/flamboyant';
import { EmbeddedSignupFlow } from '../../MetaSDK/EmbeddedSignupFlow';
import { initFacebookSDK } from '../../MetaSDK/initFacebookSDK';
import {
  ConnectionContainer,
  ConnectionCard,
  ConnectionHeader,
  ConnectionContent,
  ConnectionDescription,
  FacebookButton,
  LoadingContainer
} from './FacebookConnection.styles';

const FacebookConnection = ({ onComplete, onError, customerId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isFacebookSDKReady, setIsFacebookSDKReady] = useState(false);

  useEffect(() => {
    const initializeSDK = async () => {
      try {
        await initFacebookSDK();
        setIsFacebookSDKReady(true);
      } catch (err) {
        setError('Erro ao inicializar o Facebook SDK');
        console.error('Facebook SDK initialization error:', err);
      }
    };

    initializeSDK();
  }, []);

  const handleFacebookCallback = (response) => {
    console.log('Facebook callback received:', response);
    
    // For coexistence flow, the response structure is different
    // It should contain waba_id from the FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING event
    if (response && response.waba_id) {
      // This is the coexistence onboarding completion data
      // We need to extract the phone number and other details
      onComplete({
        wabaId: response.waba_id,
        phoneNumberId: response.phone_number_id || null,
        accessToken: response.access_token || null,
        phoneNumber: response.phone_number || null,
        displayName: response.display_name || null,
        connectionStatus: 'connected'
      });
    } else if (response && response.length > 0) {
      // Fallback for standard embedded signup response
      const data = response[0];
      onComplete({
        wabaId: data.waba_id || data.business_id,
        phoneNumberId: data.phone_number_id,
        accessToken: data.access_token,
        phoneNumber: data.phone_number,
        displayName: data.display_name,
        connectionStatus: 'connected'
      });
    } else {
      const errorMsg = 'Erro ao conectar com o Facebook. Dados incompletos recebidos.';
      console.error('Invalid Facebook callback data:', response);
      setError(errorMsg);
      if (onError) {
        onError(errorMsg);
      }
    }
  };

  const handleError = (hasError) => {
    if (hasError) {
      const errorMsg = 'Erro ao conectar com o Facebook. Verifique suas permissões e tente novamente.';
      setError(errorMsg);
      if (onError) {
        onError(errorMsg);
      }
    } else {
      setError(null);
    }
  };

  if (!isFacebookSDKReady) {
    return (
      <ConnectionContainer>
        <ConnectionCard>
          <LoadingContainer>
            <Icon icon="poli-icon pi-loading-fill" size={40} />
            <span>Inicializando conexão com Facebook...</span>
          </LoadingContainer>
        </ConnectionCard>
      </ConnectionContainer>
    );
  }

  return (
    <ConnectionContainer>
      <ConnectionCard>
        <ConnectionHeader>
          <Icon icon="poli-icon pi-facebook-fill" size={40} color="#1877F2" />
          <h3>Conectar com Facebook</h3>
        </ConnectionHeader>
        
        <ConnectionContent>
          <ConnectionDescription>
            <p>
              Para conectar seu WhatsApp Business App à plataforma, você precisa fazer login 
              com sua conta do Facebook que possui acesso ao WhatsApp Business.
            </p>
            <p>
              <strong>Importante:</strong> Certifique-se de que você tem permissões de administrador 
              na conta do WhatsApp Business que deseja conectar.
            </p>
          </ConnectionDescription>

          {error && (
            <Alert color="danger" style={{ marginBottom: '1rem' }}>
              <Icon icon="poli-icon pi-sad-line" size={20} />
              <span>{error}</span>
            </Alert>
          )}

          <FacebookButton>
            <EmbeddedSignupFlow
              onCallbackSDK={handleFacebookCallback}
              setErrorSdkFb={handleError}
              customer={customerId}
            />
          </FacebookButton>
        </ConnectionContent>
      </ConnectionCard>
    </ConnectionContainer>
  );
};

export default FacebookConnection;
